{
    "common": {
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Gio",
        "fri": "Ven",
        "sat": "Sab",
        "sun": "Dom",
        "jan": "Gen",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Giu",
        "jul": "Lug",
        "aug": "Ago",
        "sep": "Set",
        "oct": "Ott",
        "nov": "Nov",
        "dec": "Dic",
        "january": "Gennaio",
        "february": "Febbraio",
        "march": "Marzo",
        "april": "Aprile",
        "may": "Maggio",
        "june": "Giugno",
        "july": "Luglio",
        "august": "Agosto", 
        "september": "Settembre",
        "october": "Ottobre",
        "november": "Novembre",
        "december": "Dicembre",
        "checkin": "Arrivo",
        "checkout": "Partenza",
        "room": "Camera",
        "rooms": "Camere",
        "adult": "Adulto",
        "adults": "Adulti",
        "edit": "Modifica",
        "editCap": "MODIFICA",
        "delete": "Elimina",
        "deleteCap": "ELIMINA",
        "localTime": "Ora locale",
        "back": "INDIETRO",
        "home": "HOME",
        "yes": "SÌ",
        "no": "NO",
        "left": "Rimasto",
        "hour": "Ora",
        "hours": "Ore",
        "night": "notte",
        "nights": "notti",
        "for": "per",
        "why": "Perché",
        "get": "Ottieni",
        "more": "Più",
        "agree": "D'ACCORDO",
        "disagree": "NON D'ACCORDO",
        "basedOn": "basato su",
        "error": "Si è verificato un errore, riprova più tardi",
        "error2": "Fallito, riprova!",
        "error3": "Si è verificato un errore!!",
        "error4": "Si è verificato un errore!! Riprova",
        "error5": "Spiacenti!! Si è verificato un errore. Riprova tra qualche istante.",
        "hi": "Ciao",
        "to": "a",
        "free": "Gratuito",
        "per": "Per",
        "at": "a",
        "day": "Giorno",
        "days": "Giorni",
        "time": "Tempo",
        "of": "di",
        "photo": "Foto",
        "photos": "Foto",
        "done": "Fatto",
        "fullStay": "Soggiorno completo",
        "date": "Data",
        "and": "e",
        "bookingDetail": "Dettaglio prenotazione",
        "Back": "Indietro",
        "Home": "Home"
    },
    "userPopup": {
        "myAccount": "Il mio account",
        "welcome": "Benvenuto",
        "user": "Utente",
        "findMyBookings": "TROVA LE MIE PRENOTAZIONI",
        "viewProfile": "VISUALIZZA PROFILO",
        "makeAReservarion": "EFFETTUA UNA PRENOTAZIONE",
        "logout": "ESCI",
        "loginCap": "ACCEDI",
        "login": "Accedi",
        "invalidCredentials": "Credenziali non valide",
        "invalidEmail": "Email non valida",
        "passwordIsRequired": "La password è obbligatoria",
        "minChar8": "minimo 8 caratteri",
        "tooShort": "Troppo corto!",
        "tooLong": "Troppo lungo!",
        "required": "Obbligatorio",
        "emailInvalid": "Inserisci un'email valida",
        "passwordInvalid": "Inserisci una password valida",
        "phNumInvalid": "Il numero di telefono non è valido",
        "signupCap": "REGISTRATI",
        "signup": "Registrati",
        "verifyText": "Verifica che sei tu",
        "verifyText2": "Abbiamo inviato un codice di verifica alla tua email",
        "verificationCode": "Codice di verifica",
        "didNotReceiveEmail": "Non hai ricevuto l'email",
        "clickToResend": "Clicca per inviare di nuovo",
        "verifyAndSignIn": "Verifica e accedi",
        "otpSentSuccessfully": "OTP inviato con successo",
        "somethingWentWrong": "Qualcosa è andato storto, riprova",
        "otpError": "Inserisci un numero valido",
        "otpError2": "Inserisci solo numeri",
        "otpError3": "OTP errato, riprova",
        "otpError4": "OTP scaduto, clicca Invia di nuovo per riprovare",
        "otpError5": "Riprova",
        "forgetPassword": "Password dimenticata",
        "submitError": "L'utente non esiste!",
        "userExistError": "L'utente esiste già",
        "checkYourEmail": "Controlla la tua email",
        "passwordResetLinkSent": "Abbiamo inviato un link per il reset della password a",
        "noWorriesResetInstructions": "Nessun problema, ti invieremo le istruzioni per il reset.",
        "enterYourEmail": "Inserisci la tua email",
        "resetMyPassword": "REIMPOSTA LA MIA PASSWORD",
        "setANewPassword": "Imposta una nuova password",
        "newPassword": "Nuova password",
        "confirmPassword": "Conferma password",
        "confirmPasswordError": "Le password devono corrispondere",
        "backToLogin": "Torna al login",
        "dontHaveAccount": "Non hai un account?",
        "alreadyHaveAccount": "Hai già un account?",
        "memberDiscount1": "Riceverai",
        "memberDiscount2": "sconto membro per sempre.",
        "discount1": "Gestisci tutte le tue prenotazioni da un unico posto.",
        "discount2": "Registrati per consigli personalizzati ed esperienze su misura!!",
        "discount3": "Unisciti alla nostra comunità di ospiti felici e inizia a pianificare il tuo soggiorno.",
        "leftGridText1": "Gestisci tutte le tue prenotazioni da un unico posto",
        "leftGridText2": "Registrati per consigli personalizzati ed esperienze su misura!!",
        "leftGridText3": "Unisciti alla nostra comunità di ospiti felici e inizia a pianificare il tuo soggiorno",
        "gridDiscountText1": "sconto membro su",
        "gridDiscountText2": "proprietà selezionate per sempre",
        "gridDiscountText3": "Accedi per un'esperienza su misura per sempre",
        "gridDiscountText4": "Ottieni vantaggi esclusivi per i membri",
        "findBookingError": "La tua email e l'ID prenotazione non corrispondono",
        "verifyAndConfirmBooking": "Verifica e conferma prenotazione",
        "confirmEmailText": "Abbiamo inviato un codice di verifica al tuo indirizzo email",
        "enterCodeText": "Inserisci il codice di verifica che ti è stato inviato",
        "didNotRecieveEmail": "Non hai ricevuto l'email?",
        "changeEmailText": "Clicca qui per cambiare l'indirizzo email",
        "verifyAndConfirm": "Verifica e conferma",
        "verified": "VERIFICATO",
        "bookingExpired": "Prenotazione scaduta",
        "bookingExpiredText": "Ci dispiace, l'ID prenotazione che stai utilizzando è scaduto",
        "backToFindingBooking": "Torna a Trova prenotazione",
        "findMyBooking": "Trova le mie prenotazioni",
        "bookingEmail": "Email prenotazione",
        "reservationId": "ID prenotazione",
        "findBooking": "TROVA PRENOTAZIONE",
        "abandonmentCartDoneText1": "Grazie!",
        "abandonmentCartDoneText2": "I dettagli del carrello sono stati inviati all'email. Continua la tua prenotazione in qualsiasi momento.",
        "Recommended Currencies": "Valute consigliate",
        "All currencies": "Tutte le valute",
        "thisIsRequiredField": "Questo è un campo obbligatorio"
    },
    "widget": {
        "destination": "Destinazione",
        "enterDestination": "Inserisci destinazione",
        "guests": "Ospiti",
        "guest": "Ospite",
        "nationality": "Nazionalità",
        "selectNationality": "Seleziona la nazionalità",
        "nationalityIsRequired": "La nazionalità è obbligatoria",
        "selectedRate": "Tariffa speciale",
        "search": "Cerca",
        "ages": "Età",
        "orAbove": "O superiore",
        "child": "Bambino",
        "children": "Bambini",
        "addAnotherRoom": "Aggiungi un'altra camera",
        "removeRoom": "Rimuovi camera",
        "property": "Proprietà",
        "city": "Città",
        "country": "Paese",
        "bookNow": "Prenota ora",
        "overnightStay": "Soggiorno notturno",
        "dayUse": "Uso giornaliero",
        "destinationIsRequired": "La destinazione è obbligatoria",
        "checkInIsRequired": "La data di check-in è obbligatoria",
        "checkOutIsRequired": "La data di check-out è obbligatoria",
        "noLocationFound": "Nessuna posizione trovata",
        "soldOut": "Esaurito",
        "highDemand": "Alta domanda",
        "dates": "Date",
        "allRates": "Tutte le tariffe sono in",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Check-out nello stesso giorno"
    },
    "promotion": {
        "headingText": "Informazioni importanti per",
        "regularRate": "Nessuno",
        "seniorCitizen": "Tariffa per anziani",
        "agencyRate": "Tariffa agenzia",
        "caaRate": "Tariffa CAA/AAA",
        "corporateRate": "Tariffa aziendale",
        "governmentRate": "Tariffa governativa/militare",
        "promotionalSpecialRate": "Tariffa promozionale/speciale",
        "regularRateDescription": "Nessuna promozione applicata.",
        "seniorCitizenRateDescription": "Questa è una tariffa alberghiera scontata ampiamente disponibile per gli adulti più anziani, tipicamente di 60 anni o più.",
        "agencyRateDescription": "Questa è una tariffa alberghiera scontata offerta a cui è possibile accedere solo attraverso agenti di viaggio specifici che favoriscono partnership e collaborazione.",
        "caaRateDescription": "Questa è una tariffa speciale offerta ai membri di AAA o CAA per risparmi esclusivi.",
        "corporateRateDescription": "Questa è una tariffa alberghiera scontata estesa ai viaggiatori d'affari, tipicamente negoziata tra l'hotel e l'entità aziendale.",
        "governmentRateDescription": "Questo piano tariffario offre sconti specifici per il personale governativo/militare per la prenotazione di una camera d'albergo.",
        "contentSeniorCitizen": "La prova della data di nascita è obbligatoria al momento del check-in. La mancata presentazione di un documento d'identità pertinente comporterà l'addebito delle tariffe vigenti.",
        "contentAgencyRate": "Assicurati di avere la conferma della prenotazione e la prova d'identità all'arrivo. La mancata presentazione di questi comporterà l'applicazione delle tariffe standard.",
        "contentPromotionalSpecialRate": "Questa è una tariffa alberghiera scontata offerta per un periodo limitato, spesso legata a eventi specifici, stagioni o campagne di marketing.",
        "contentCaaRate": "Assicurati di avere la tua tessera di iscrizione CAA o un'identificazione pertinente al momento del check-in. La mancata presentazione di un documento d'identità pertinente comporterà l'addebito delle tariffe vigenti.",
        "contentCorporateRate": "La prova dell'ID aziendale o altra documentazione ufficiale è richiesta al momento del check-in. La mancata presentazione di una prova pertinente comporterà l'addebito delle tariffe vigenti.",
        "contentGovernmentRate": "Un documento d'identità governativo o militare valido deve essere fornito al check-in. La mancata presentazione dell'identificazione richiesta comporterà addebiti alla tariffa standard.",
        "CORP": "AZIENDA",
        "AGEN": "AGENZIA",
        "PROM": "PROMO",
        "apply": "APPLICA",
        "Offer Code": "Codice offerta",
        "Agency Code": "Codice agenzia",
        "Corporate Code": "Codice aziendale",
        "All-Access Rate": "Tariffa con accesso completo",
        "errorCode": "Questo codice non è valido"
    }
}